export type Language = "D" | "E" | "F" | "FR" | "NL" | "CS" | "ZH" | "GR" | "I" | "J" | "PL" | "RUS" | "ESP";


export type LanguageCode = "D" | "E" | "F" | "FR" | "NL" | "CS" | "ZH" | "GR" | "I" | "J" | "PL" | "RUS" | "ESP";
export type PitLanguageSuffix = "_D" | "_E" | "_F" | "_FR" | "_NL" | "_C" | "_CN" | "_GR" | "_I" | "_J" | "_PL" | "_RUS" | "_ESP";
export enum PitLanguageSuffixes {
    "german" = "_D",
    "english" = "_E",
    "french" = "_F",
    "french2" = "_FR", // manche pit haben _F, manche _FR, deshalb hier überall unterscheiden...
    "dutch" = "_NL",
    "czech" = "_C",
    "chinese" = "_CN",
    "greek" = "_GR",
    "italian" = "_I",
    "japanese" = "_J",
    "polish" = "_PL",
    "russian" = "_RUS",
    "spanish" = "_ESP"
}
export enum PitLanguageMap {
    "_D" = "D",
     "_E" = "E",
     "_F" = "F",
     "_FR" = "FR",
    "_NL" = "NL",
  "_C" = "CS",
    "_CN" = "ZH",
    "_GR" = "GR",
    "_I" = "I",
    "_J" = "J",
   "_PL" = "PL",    
    "_RUS" = "RUS",
    "_ESP" = "ESP"
}

export enum CountryCode2 {
    D = "DE",
    E = "EN",
    F = "FR",
    FR = "FR",
    NL = "NL",
    C = "CZ",
    ZH = "ZH",
    GR = "EL",
    I = "IT",
    J = "JA",
    PL = "PL",
    RUS = "RU",
    ESP = "ES"
}

export enum CountryCodeIti {
    D = "de",
    E = "us",
    F = "fr",
    FR = "fr",
    NL = "nl",
    C = "cz",
    CS = "cz",
    CN = "cn",
    ZH = "cn",
    GR = "gr",
    I = "it",
    J = "jp",
    PL = "pl",
    RUS = "ru",
    ESP = "es"
}

export enum LanguagesGerman {
    D = "Deutsch",
    E = "Englisch",
    F = "Französisch",
    FR = "Französisch",
    NL = "Niederländisch",
    C = "Tschechisch",
    CS = "Tschechisch",
    CN = "Chinesisch",
    ZH = "Chinesisch",
    GR = "Griechisch",
    I = "Italienisch",
    J = "Japanisch",
    PL = "Polnisch",
    RUS = "Russisch",
    ESP = "Spanisch"
}

export enum LanguagesEnglish {
    D = "German",
    E = "English",
    F = "French",
    FR = "French",
    NL = "Dutch",
    C = "Czech",
    CS = "Czech",
    CN = "Chinese",
    ZH = "Chinese",
    GR = "Greek",
    I = "Italian",
    J = "Japanese",
    PL = "Polish",
    RUS = "Russian",
    ESP = "Spanish"
}

interface Translation {
    detected_source_language: string;
    text: string;
}

export interface TranslationResponse {
    translations: Translation[];
    translationResult?: string;
}

export type LanguagesEnum = LanguagesGerman | LanguagesEnglish;